import React, { useEffect } from 'react'
import { DashboardContentContainer } from './styles'
import { GeneralSidePanel } from '../sidePanel'
import { GeneralMainPanel } from '~/components/generalMedicalView'
import { OpenCloseProvider, useGeneralHealthProcedures, usePatient } from '~/context'
import { EViewOptions } from '~/interfaces'

import { CreateHealthProcedureDetails } from '~/components/healthProcedures/CreateHealthProcedureDetails'

export const GeneralContent = (): JSX.Element => {
  const { patient } = usePatient()
  const generalHealthProcedures = useGeneralHealthProcedures()
  const {
    getHealthProcedures,
    displayedHealthProcedures,
    isLoadingTimeline,
    mainContentType,
    changeMainContentType,
    modalHealthProcedure,
    closeHealthProcedureDetails
  } = generalHealthProcedures

  useEffect(() => {
    getHealthProcedures({ pathParams: { patientId: patient.id } })
  }, [getHealthProcedures, patient.id])

  const hasData = (): boolean => {
    return !!(displayedHealthProcedures && displayedHealthProcedures.length > 0)
  }

  const isFetchingHealthProcedures = (): boolean => {
    return isLoadingTimeline
  }

  const toggleContent = (event: React.MouseEvent): void => {
    if (mainContentType === EViewOptions.HUMAN_BODY) {
      event.stopPropagation()
      changeMainContentType(EViewOptions.TIMELINE)
    }
  }

  return (
    <>
      <DashboardContentContainer onClick={toggleContent}>
        <OpenCloseProvider>
          <GeneralMainPanel
            contentType={mainContentType}
            isLoading={isFetchingHealthProcedures()}
            hasData={hasData()}
          />
          <GeneralSidePanel contentType={mainContentType} />
        </OpenCloseProvider>
      </DashboardContentContainer>
      <CreateHealthProcedureDetails
        handleSelectedModalHealthProcedures={closeHealthProcedureDetails}
        selectedPatient={() => patient.id}
        modalHealthProcedure={modalHealthProcedure}
      />
    </>
  )
}
